import * as Sentry from '@sentry/react';
import Utils from './utils/utils';

/**
 * Error reporting for the portal.
 *
 * Imported from index.js before App so the global handlers are in place before
 * any page code runs - an error thrown while the app boots is exactly the kind
 * we would otherwise never hear about.
 *
 * Off in local development: `npm start` errors belong in the dev overlay, not
 * in the project's issue list. Staging and production both report, tagged with
 * their environment so they can be filtered apart.
 *
 * Pinned to @sentry/react v8 on purpose. v9 and later ship ES2020 syntax, which
 * the webpack 4 that react-scripts 4 bundles cannot parse.
 */
const SENTRY_DSN = 'https://d1525ac8a7eb9197c5fa702c5b033239@o4509374318444554.ingest.us.sentry.io/4512141408927744';

const getEnvironment = () => {
  if (Utils.isDevEnv()) return 'development';
  if (Utils.isStagingEnv()) return 'staging';
  return 'production';
};

Sentry.init({
  dsn: SENTRY_DSN,
  enabled: !Utils.isDevEnv(),
  environment: getEnvironment(),
  release: process.env.REACT_APP_VERSION ? `ipermit-custom-portal@${process.env.REACT_APP_VERSION}` : undefined,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
});

export default Sentry;
